import React from 'react';
// import metlifeLogo from '../utilities/images/MetlifeLogo.PNG';

const Footer = () => {
  const currentYear = new Date().getFullYear();

    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', padding: '0.5rem', backgroundColor: 'white', justifyContent: 'center'}}>
            {/* <img src={metlifeLogo} alt="Metlife Logo" />  */}
            {/* <p style={{paddingLeft:'20px'}}>© 2024 MetLife Services and Solutions, LLC</p> */}
              {/* Adding Privacy Policy and Terms of Use links */}
              <a href="https://www.metlife.com/about-us/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{paddingLeft:'20px', textDecoration: 'none'}}>Privacy Policy</a>
                <a href="https://www.metlife.com/about-us/terms-and-conditions/" target="_blank" rel="noopener noreferrer" style={{paddingLeft:'20px', textDecoration: 'none'}}>Legal Notice</a>
                {/* <p style={{paddingLeft:'20px'}}>© 2024 MetLife Services and Solutions, LLC</p> */}
        </div>
        <div style={{display: 'flex', alignItems: 'center', padding: '0.5rem', backgroundColor: 'white', justifyContent: 'center'}}>
            {/* <img src={metlifeLogo} alt="Metlife Logo" />  */}
            {/* <p style={{paddingLeft:'20px'}}>© 2024 MetLife Services and Solutions, LLC</p> */}
              {/* Adding Privacy Policy and Terms of Use links */}
              
                <p style={{paddingLeft:'20px'}}>© {currentYear} MetLife Services and Solutions, LLC. New York, NY 10166 - All Rights Reserved.</p>
        </div>
        </>
        
    );
};

export default Footer;